var _defs, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlatinum = function SvgPlatinum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "platinum_svg__a",
    x1: 13.024,
    y1: 1,
    x2: 13.024,
    y2: 25.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#F3D223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F2994A"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.532 8.272-6.846-6.467A12.27 12.27 0 0 0 13.303 1C6.508 1 1 6.508 1 13.303c0 1.792.384 3.495 1.073 5.031l6.847 6.467c.998.261 2.745.247 3.825.247 6.795 0 12.303-5.508 12.303-12.303 0-1.314-.134-3.286-.516-4.473Zm-11.23 7.873c-.356 0-.697-.067-1.012-.187h-1.58v-1.493a2.842 2.842 0 0 1 3.605-3.817h1.58v1.493a2.842 2.842 0 0 1-2.593 4.004Z",
    fill: "url(#platinum_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.995 8.513c.381 1.188.588 2.454.588 3.768 0 6.795-5.508 12.303-12.302 12.303-1.08 0-2.127-.14-3.125-.4H8.92v.618c1.362.52 2.839.805 4.383.805 6.794 0 12.302-5.509 12.302-12.303 0-1.793-.383-3.496-1.072-5.032h-.538v.241Z",
    fill: "#FAD846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.29 15.959a2.85 2.85 0 0 1-1.58-1.494l-8.637 3.87a12.316 12.316 0 0 0 2.035 3.14c1.59 1.498 3.58 2.708 5.048 2.708l3.135-8.224ZM14.315 10.647a2.85 2.85 0 0 1 1.58 1.494l8.099-3.628c0-1.194-.906-2.666-2.52-4.405a12.297 12.297 0 0 0-3.789-2.303l-3.37 8.842Z",
    fill: "#FAD846"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.533 8.272a12.334 12.334 0 0 0-3.057-4.164 12.285 12.285 0 0 1 2.519 4.405l.538-.24Z",
    fill: "#F3BB33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11 21.477a12.323 12.323 0 0 0 4.811 3.325l.236-.619a12.273 12.273 0 0 1-5.048-2.706Z",
    fill: "#F2A642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.585,
    cy: 13.587,
    fill: "#36373C",
    r: 3.524
  })));
};
export default SvgPlatinum;